import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { NFT_LIST, NFT_BUYERS, USER_PERK } from "../constants/urls";
import NFTNav from "../components/NavComponents/NFTNav";
import Card from "../components/desktop/Card";
import EarlyAccessFooter from "../components/desktop/EarlyAccessFooter";
import ModalBidComponent from "../components/BidComponents/PlaceBidModalComponent";
import ModalMetamaskInstallComponent from "../components/MetamaskInstallComponent/ModalMetamaskInstallComponent";

import StreamPowerExplainerVideoComponent from  '../components/StreamPowerComponents/StreamPowerExplainerVideoComponent';
import StreamPowerImageComponent from "../components/StreamPowerComponents/StreamImageComponent";
import BuyStreamPowerComponent from "../components/StreamPowerComponents/BuyStreamPowerComponent";
import PowersListComponent from "../components/StreamPowerComponents/PowersListComponent";

import {
    useHistory,
} from "react-router-dom";
import twitch from '../assets/twitch.svg';
import box_frame from '../assets/box_frame.png';
import supermessage from '../assets/powers/supermessage.png';
import flashbang from '../assets/powers/flashbang.png';
import autograph from '../assets/powers/autograph.png';
import supermessage_asset from '../assets/powers/supermessage_asset.png';
import flashbang_asset from '../assets/powers/flashbang_asset.png';
import autograph_asset from '../assets/powers/autograph_asset.png';
import eventBus from '../utils/globalPubSub';
import {
    fetchUserDirectPerks,
    convertUserDirectPerksToDict} from '../utils/perksUtils';

import { PaymentContext } from '../utils/paymentConfigProvider';
import { useLocation } from "react-router-dom";
import {
    fetchPaymentConfigFromBackend,
    fetchUserPaymentConfigFromBackend} from '../utils/backendUtils';


const CoinGecko = require('coingecko-api');
const CoinGeckoClient = new CoinGecko();


const url = window.location;
let domain = (new URL(url));
domain = domain.origin;


const Mobile = styled.div`
  display: none;
  background: #000;
  @media only screen and (max-device-width: 480px) {
  display: flex;
  flex-direction: column;
  }
`;

const CollectorsTitle = styled.div`
  margin-top: 65px;
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 90.1%;
  /* identical to box height, or 38px */

  display: flex;
  align-items: center;

  color: ${props => props.active ? '#FFFFFF': 'rgba(255,255,255,0.45)'};
  margin: 4px;

  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  text-align: center;
  margin-top: 36px;
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  height: 100%;
  /* overflow: hidden; */
  }
`;

const Container = styled.div`
  padding: 12px 120px;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  /* height: 100vh; */
`;

const MobileContainer = styled.div`
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  /* height: 100vh; */
`;


const CollectorAddress = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 90.1%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
`;

const CollectorBoughtTime = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.4;
`;

const Perks = styled.div`
  font-family: 'Space Mono';
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 90.1%;
  color: #FFFFFF;
`;


const CollectorItemBought = styled.a`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.4;
`;

const Username = styled.div`    
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 90.1%;
    /* or 25px */
    text-transform: uppercase;
    color: #FFFFFF;
`;


const GradientButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
`;


const GreenButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: rgba(0, 126, 34, 1);
    background-blend-mode: overlay;
    border-radius: 12px;
`;


const LightPurpleButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: rgba(151, 32, 228, 1);
    background-blend-mode: overlay;

    border-radius: 12px;
`;


const PurpleButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: #650054;
    border-radius: 12px;
`;


const PowersWrapper = styled.div`
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    margin-bottom: 25px;
`;


const PowersStock = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    /* identical to box height, or 21px */

    letter-spacing: 0.05em;
    text-transform: uppercase;

    color: #FFFFFF;
    margin-top: 14px;
`;

const PowersTitle = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 90.1%;
    /* or 18px */

    text-align: center;

    color: #FFFFFF;
    margin-top: 8px;
`;

const PowerPrice = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    margin-top: 8px;
`;


const HeaderTitle = styled.div`    
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    /* identical to box height, or 21px */

    letter-spacing: 0.05em;
    text-transform: uppercase;

    color: #FFFFFF;

    opacity: 0.4;
`;


const HeaderValue = styled.div`    
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 90.1%;
    /* identical to box height, or 22px */

    text-align: right;

    color: #FFFFFF;
`;

const GreyTitle = styled.div`    
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height */

    display: flex;
    align-items: center;

    color: #FFFFFF;

    opacity: 0.4;
`;

const Whitetitle = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    /* or 162% */

    display: flex;
    align-items: flex-end;

    color: #FFFFFF;
`;

const DesktopList = styled.div`
    @media only screen and (max-device-width: 480px) {
        margin: 0px!important;
    }
`;


function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}


const PowerImage = ({powerId}) => {
    if(powerId == 14)
        return (<img style={{width: 48, marginRight: 18}} src={supermessage_asset} />);
    return (<img style={{width: 48, marginRight: 18}} src={supermessage_asset} />);
}

export default function UserStoreItem(props) {    
    const [glip, setGlip] = useState({});
    const [data, dataSet] = useState();
    const [videos, videosSet] = useState([]);
    const [activeTab, setActiveTab] = useState('NFT');
    const [perkBanners, setPerkBanners] = useState([]);
    const [collectors, setCollectors] = useState([]);
    const [bids, setBids] = useState([]);
    const [perks, setPerks] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [startWithWithdraw, setStartWithWithdraw] = useState(false);
    const [startWithDeposit, setStartWithDeposit] = useState(false);
    const [maticPrice, setMaticPrice] = useState(0);
    const [powers, setPowers] = useState([]);
    const [power, setPower] = useState();

    const history = useHistory();
    const location = useLocation();
    const { item, username } = useParams();
    const paymentConfig = useRef({});

    const [ownedPerksDict, setOwnedPerksDict] = useState({});
    
    
    const setPaymentConfig = (newVal, key) => {
        console.log('paymentConfig.current', newVal);
        if(key){
            paymentConfig.current[key] = newVal;
        }
        forceUpdate();
    }

    const forceUpdate = useForceUpdate();

    eventBus.on("success-perk-buy", () => {
        fetchUserDirectPerksFromBackend();
    })
    
    const fetchUserDirectPerksFromBackend =  async  ()=> {
        let userDirectPerks:any = await fetchUserDirectPerks(
            username);
        console.log('userDirectPerks', userDirectPerks)
        if(!userDirectPerks ){
            return;
        }
        console.log('userDirectPerks',
                    userDirectPerks.data.directUserPerks[0]);
        let userPerksDict = convertUserDirectPerksToDict(
            userDirectPerks.data.directUserPerks);
        setOwnedPerksDict(userPerksDict);
        console.log(
            'userDirectPerksDict',
            convertUserDirectPerksToDict(
                userDirectPerks.data.directUserPerks));
    }
    
    const checkIsIndiaPayment = (tpaymentConfig)=>{
        console.log('isIndiaPaymentisIndiaPayment', tpaymentConfig);
        if(!tpaymentConfig || !tpaymentConfig.current){
            return false;
        }
        if(!tpaymentConfig.current.creatorConfig){
            return false;
        }
        if(!tpaymentConfig.current.creatorConfig.config.acceptedCurrencies){
            return false
        }
        if(tpaymentConfig.current.creatorConfig.config.acceptedCurrencies.includes('INR')){
            return true;
        }
    }
    const isIndiaPayment = checkIsIndiaPayment(paymentConfig);
    console.log('isIndiaPaymentisIndiaPayment', isIndiaPayment);
    let currencyString ='$';
    if(isIndiaPayment){
        currencyString = `\u20B9`;
    }
    
    useEffect(() => {
        fetchUserDirectPerksFromBackend();
    }, [username]);
    
    const usePower = () => {
        let ownedPower = ownedPerksDict[power.id];
        console.log('ownedPower', ownedPower);
        history.push({
            pathname: `/power/${ownedPower._id}`,
            state: {power:power}})
    };
    
    useEffect(() => {
        if(powers.length > 0) {
            for(var i=0; i < powers.length; i++) {
                if(powers[i].id == item) setPower(powers[i]);
            }    
            console.log(power, '===============[pwers');
        }
    }, [powers]);
       


    useEffect(() => {
        async function fetchMyAPI() {
            // TODO Change endpoint
            let response = await fetch(USER_PERK + `?username=${username}`);
            //let response = await fetch(USER_PERK + `?userId=244`);
            response = await response.json();
            
            if(response.data) {
                console.log(response.data.perks, '=================perks');
                setPowers(response.data.perks);
                dataSet(true);
            }
        }
	fetchMyAPI();
    }, [item, username]);        
    

    
    const fetchPaymentConfig = async () => {
        let tpaymentConfig = await fetchPaymentConfigFromBackend(
            username);
        console.log(
            'paymentConfigpaymentConfig',
            tpaymentConfig.data);
        setPaymentConfig(tpaymentConfig.data, 'creatorConfig');
    }

    const fetchUserPaymentConfig = async () => {
        let tpaymentConfig = await fetchUserPaymentConfigFromBackend(
            username);
        console.log(
            'paymentConfigpaymentConfig',
            tpaymentConfig.data);
        setPaymentConfig(tpaymentConfig.data, 'userConfig');
        }

    
    useEffect(()=>{
        fetchPaymentConfig();
        fetchUserPaymentConfig();
    },[])
    // if(!location && !location.state && !location.state.length && powers.length == 0 && !power) return (<></>);
    if(!power) return (<></>);
    
    console.log(location, location.state)  
    
    if (false && !data) {
        return <>
                <Desktop>
                    <NFTNav
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        creator={username}
                        userChainId={1}
                        showTabs={false}
                        expanded={false}
                    />
                </Desktop>
            </>;
    }
    
    
    return (
	<PaymentContext.Provider value={paymentConfig.current}>
            <NFTNav
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                creator={username}
                handleWithdrawClicked={()=>{handleWithdrawClicked()}}
                handleDepositClicked={()=>{handleDepositClicked()}}
                userChainId={1}
                showTabs={true}
                expanded={false}
            />
            <Mobile>
                <MobileContainer>
                    <StreamPowerExplainerVideoComponent style={{
                        flex: 2, maxWidth: '100%'}}  previewVideoUri={power.previewVideoUri}   powerType={power.data.type}>
                    </StreamPowerExplainerVideoComponent>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 26,
                        marginTop: 20}}>
                        <PowerImage powerId={power.id} />
                        <Username>{power.name}</Username>
                    </div>
                    <div style={{flex: 1, flexDirection: 'column',}}
                    >
                        <div style={{background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12,}}>
                            <div style={{display: 'flex', justifyContent: 'space-between',  padding: 18}}>
                                <div>
                                    <HeaderTitle>PRICE</HeaderTitle>
                                    <HeaderValue>{currencyString}{power.data.price}</HeaderValue>
                                </div>
                                {/* <div>
                                    <HeaderTitle>IN STOCK</HeaderTitle>
                                    <HeaderValue>32</HeaderValue>
                                    </div> */}
                            </div>
                            <div style={{padding: 16, background: '#1A1B1A', borderBottomLeftRadius: 12, borderBottomRightRadius: 12}}>
                                {!(power.id in ownedPerksDict) && (
                                    <BuyStreamPowerComponent
                                        power={power}
                                        creatorName={username}
                                    >
                                    </BuyStreamPowerComponent>)}
                                {(power.id in ownedPerksDict) && <div 
                                                                     style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                                    <GradientButton className='hover' style={{width: '100%'}} onClick={() => usePower()}>USE POWER</GradientButton>
                                    {/* <GradientButton className='hover' style={{marginLeft: 12, background: 'rgba(255, 255, 255, 0.08)', width: '100%'}}>BUY MORE</GradientButton> */}
                                </div>
                                }
                            </div>                            
                        </div>
                        <GreyTitle style={{marginTop: 24, marginBottom: 12}}>POWER DESCRIPTION</GreyTitle>
                        <Whitetitle>{power.description}</Whitetitle>
                        <br></br>                    
                        <Whitetitle>{power.funny_description}</Whitetitle>                   
                    </div>
                    <PowersWrapper style={{marginTop:30}}>
                        <Username>MORE POWERS</Username>
                        <div style={{display: 'flex', marginLeft: -20, marginTop: 24, flexWrap: 'wrap', justifyContent:'center'}}>
                            <PowersListComponent
                                username={username}
                                powers={powers}
                                ownedPerksDict={ownedPerksDict}
                            >
                            </PowersListComponent>
                        </div>
                    </PowersWrapper>
                </MobileContainer>
            </Mobile>
	    <Desktop>
                <Container>
                    <br></br><br></br>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: 26}}>
                        <PowerImage powerId={power.id} />
                        <Username>{power.name}</Username>
                    </div>



                    <div style={{display: 'flex', justifyContent: 'flex-start', marginBottom: 26}}>
                        <StreamPowerExplainerVideoComponent style={{
                            flex: 2, maxWidth: '66%'}} previewVideoUri={power.previewVideoUri} powerType={power.data.type}>
                        </StreamPowerExplainerVideoComponent>
                        <div style={{marginLeft: 44, flex: 1, flexDirection: 'column',}}
                        >
                            <div style={{background: 'rgba(255, 255, 255, 0.08)', borderRadius: 12,}}>
                                <div style={{display: 'flex', justifyContent: 'space-between',  padding: 18}}>
                                    <div>
                                        <HeaderTitle>PRICE</HeaderTitle>
                                        <HeaderValue>{currencyString}{power.data.price}</HeaderValue>
                                    </div>
                                    {/* <div>
                                        <HeaderTitle>IN STOCK</HeaderTitle>
                                        <HeaderValue>32</HeaderValue>
                                        </div> */}
                                </div>
                                <div style={{padding: 16, background: '#1A1B1A', borderBottomLeftRadius: 12, borderBottomRightRadius: 12}}>
                                    {!(power.id in ownedPerksDict) && (
                                        <BuyStreamPowerComponent
                                            power={power}
                                            creatorName={username}
                                        >
                                        </BuyStreamPowerComponent>)}
                                    {(power.id in ownedPerksDict) && <div 
                                                                         style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                                        <GradientButton className='hover' style={{width: '100%'}} onClick={() => usePower()}>USE POWER</GradientButton>
                                        {/* <GradientButton className='hover' style={{marginLeft: 12, background: 'rgba(255, 255, 255, 0.08)', width: '100%'}}>BUY MORE</GradientButton> */}
                                    </div>
                                    }
                                </div>                            
                            </div>
                            <GreyTitle style={{marginTop: 24, marginBottom: 12}}>POWER DESCRIPTION</GreyTitle>
                            <Whitetitle>{power.description}</Whitetitle>
                            <br></br>                    
                            <Whitetitle>{power.funny_description}</Whitetitle>                        
                        </div>                    
                    </div>
                    <PowersWrapper>
                        <Username>MORE POWERS</Username>
                        <div style={{display: 'flex', marginLeft: -20, marginTop: 24, flexWrap: 'wrap'}}>
                            <PowersListComponent
                                username={username}
                                powers={powers}
                                ownedPerksDict={ownedPerksDict}
                            >
                            </PowersListComponent>
                        </div>
                    </PowersWrapper>
                </Container>		
                <EarlyAccessFooter />
	    </Desktop>
	</PaymentContext.Provider>
    );
}

